import { c as colors } from './variables-80f55df9.js';

/* 02.Ellipsis Multiline */
function ellipsis(fontSize, lineHeight, lines) {
    var height = fontSize * lineHeight * lines;
    return function () { return "\n        display: -webkit-box;    \n        overflow: hidden;\n        max-height: ".concat(height, "rem;\n        -webkit-line-clamp: ").concat(lines, ";\n        -webkit-box-orient: vertical;\n        text-overflow: ellipsis;\n        "); };
}
/* 03.Item's witdth */
function itemsWidth(itemsNumber) {
    return function () { return "\n        calc(100%/".concat(itemsNumber, ")\n    "); };
}
/* 04.Default Link */
/* Usage default: ${(props) => props.theme.mixins.defaultLink("","")}; */
/* Usage custom color: ${(props) => props.theme.mixins.defaultLink(props.theme.colors.primary.default ,props.theme.colors.primary.default)}; */
function defaultLink(color, colorHover) {
    return function () { return "\n        color: ".concat(!color ? colors.secondary800 : color, ";\n        text-decoration: none;    \n\n        &:hover {\n            color: ").concat(!colorHover ? colors.secondary : colorHover, ";\n            text-decoration: underline;\n        }\n    "); };
}
/* 05.Img fit */
function imgFit(position) {
    return function () { return "\n        img {\n            object-fit: scale-down;\n            object-position: ".concat(!position ? "center" : position, ";\n            width: 100%;\n            height: 100%;\n        }\n    "); };
}
/* 06.Standard ad */
function adStandard(flow) {
    return function () { return "        \n        display: flex;\n        width: 100%;\n        justify-content: center;\n        ".concat(flow === "horizontal" && "align-items: center;", ";\n    "); };
}
var mixins = {
    ellipsis: ellipsis,
    itemsWidth: itemsWidth,
    defaultLink: defaultLink,
    imgFit: imgFit,
    adStandard: adStandard,
};

export { mixins as m };
//# sourceMappingURL=mixins-9b684934.js.map
